import React from "react";
import { ApplicationContext } from "src/context";
import GuestSelector from "src/@components/input.guests.picker";
import Icon from "src/components/icon";

type RoomPickerProps = {
    rooms?: Array<GuestSelectorValue[]>;
    ageCategories: Array<TAgeCategory>;
    onChange: (rooms: Array<GuestSelectorValue[]>) => void;
};

export default class RoomPicker extends React.Component<RoomPickerProps> {

    /** @ts-ignore-next */
    public context!: React.ContextType<typeof ApplicationContext>;
    static contextType = ApplicationContext;

    static getHumanReadableQuantities(rooms: Array<GuestSelectorValue[]> = [], ageCategories: TAgeCategory[], context: React.ContextType<typeof ApplicationContext>): string {
        const isMultiRoom = rooms.length > 1;
        const summ: Record<string, number> = {};
        const prefix = isMultiRoom ? `${rooms.length} ${context.literal('roompicker_rooms')}, `.toLocaleLowerCase() : '';

        for (const room of rooms) {
            for (const guest of room) {
                summ[guest.type] = summ[guest.type] || 0;
                summ[guest.type] += 1;
            }
        }

        const parts = [];
        for (const agecat of ageCategories) {
            if (summ[agecat.type] > 0) {
                if (summ[agecat.type] === 1) parts.push(`1 ${context.translate(agecat.translations, 'name')}`.toLocaleLowerCase());
                else parts.push(`${summ[agecat.type]} ${context.translate(agecat.translations, 'plural')}`.toLocaleLowerCase());
            }
        }

        return prefix + parts.join(", ");
    }

    static getDefaultValue(ageCategories: TAgeCategory[], overrides: Record<string, number>) {
        return [GuestSelector.getDefaultValue(ageCategories, overrides)];
    }

    public addRoom() {
        const rooms: Array<GuestSelectorValue[]> = [...(this.props.rooms || []), GuestSelector.getDefaultValue(this.props.ageCategories)];
        this.props.onChange(rooms);
    }

    public removeRoom(index: number){
        const rooms = [...this.props.rooms || []];
        if (rooms.length && rooms.length > 1) rooms.splice(index, 1);
        this.props.onChange(rooms);
    }

    private onGuestSelectorChange(guestSelectorValue: GuestSelectorValue[], index: number){
        const rooms: Array<GuestSelectorValue[]> = [...this.props.rooms || []];
        rooms[index] = [...guestSelectorValue];
        this.props.onChange(rooms);
    }

    private stopEvent(ev: React.MouseEvent<HTMLButtonElement>) {
        ev.preventDefault()
        ev.stopPropagation()
        ev.nativeEvent.stopImmediatePropagation()
        return false
    }

    render(): React.ReactNode {
        const rooms_text = this.context.literal('roompicker_room');
        const addroom_text = this.context.literal('roompicker_add_room');

        return <div className="w-full flex flex-col gap-4">
            {this.props.rooms?.map((room, idx) => {
                return (
                    <div className="flex flex-col gap-2" key={`guest-selector-${idx}`}>
                        
                        <div className="flex flex-row w-full gap-2 justify-between mb-2">
                            <div className="font-bold">{rooms_text} {idx + 1}</div>
                            
                            {idx > 0 ?
                            <button className="buttonTextThin" onClick={(ev) => { this.stopEvent(ev); this.removeRoom(idx) }}>
                                <Icon className="h-4 w-4" icon="X" />
                            </button>
                            : null}
                        </div>

                        <div className="w-full flex flex-row">
                            <GuestSelector
                                ageCategories={this.props.ageCategories}
                                guests={room}
                                onChange={(e) => this.onGuestSelectorChange(e, idx)}
                            />
                        </div>
                    </div>
                )
            })}
            <div className="flex justify-between">
                <button className="buttonThin text-[color:var(--primaryColor)]" onClick={() => this.addRoom()}>{addroom_text}</button>
            </div>
    </div>
    }
}